import * as React from 'react';

import { BrowserRouter as Router, Navigate, Route, Routes, useParams } from 'react-router-dom';

import { TrackRouteChange } from '@components/TrackRouteChange';

import { HighlightPage } from './pages/ClipPage';
import { HighlightReelPage } from './pages/HighlightReelPage';
import { InsightPage } from './pages/InsightPage';
import { RepoSessionPage } from './pages/RepoSessionPage';

const HighlightRedirector = () => {
  const { token } = useParams<{ token: string }>();
  return <Navigate replace to={`/h/${token}`} />;
};
export const PublicAssetApp: React.FC<React.PropsWithChildren<unknown>> = () => {
  return (
    <Router>
      <TrackRouteChange />
      <Routes>
        <Route path='/h/:token' element={<HighlightPage />} />
        <Route path='/insights/:slug' element={<InsightPage />} />
        <Route path='/clips/:token' element={<HighlightRedirector />} />
        <Route path='/sessions/:uuid' element={<RepoSessionPage />} />
        <Route path='/highlight_reels/:token' element={<HighlightReelPage />} />
      </Routes>
    </Router>
  );
};
